import { render, staticRenderFns } from "./AddressRow.vue?vue&type=template&id=67c2358c&"
import script from "./AddressRow.ts?vue&type=script&lang=ts&"
export * from "./AddressRow.ts?vue&type=script&lang=ts&"
import style0 from "./AddressRow.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports